import {
    IUserSearchOptions,
    IUsersResponse,
    IUserState,
} from './Users-types';
import api from '../../helpers/api';
import Router from '../../router';
import { getUsers } from '../../helpers/general';

const roomListState: IUserState = {
    state: {
        users: [],
        pages: 0,
        pageSize: 100,
    },
    mutations: {
        setUsers(state, usersResponse: IUsersResponse) {
            state.users = usersResponse.page === 1 ?
                usersResponse.users :
                [...state.users, ...usersResponse.users];
            state.pages = usersResponse.pages;
            state.pageSize = usersResponse.pageSize;
        },
    },
    actions: {
        async getUsers({ commit }, options: IUserSearchOptions) {
            const response = await getUsers(options);

            if (response.ok) {
                const usersResponse: IUsersResponse = await response.json();
                commit('setUsers', usersResponse);
            } else if (response.status === 401) {
                Router.push({ name: 'login' });
            }
        },
    },
};

export default roomListState;
